import React from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux'
import store from './app/redux/store'

import { getElementById } from "./app/compatdom";
import App from "./app";

import { BrowserRouter} from "react-router-dom";


const render = () => {
  const APPElm = getElementById("APP");
  if (!APPElm) {
    return;
  }

  ReactDOM.render(
    <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
    </BrowserRouter>
    ,
    APPElm
  );
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", render);
} else {
  render();
}
